import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus, { ElTooltip } from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/style/common.scss'
import { hasAuth, hasBtnAuth, hasPageAuth } from '@/utils/auth'

// 全局设置所有 tooltip 默认深色主题，解决 show-overflow-tooltip 白底问题
if (ElTooltip.props && ElTooltip.props.effect) {
  ElTooltip.props.effect.default = 'dark'
}

function trimSearchInputValue(target) {
  const isInputElement = target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement
  if (!isInputElement || target.readOnly || target.disabled) return
  if (!target.closest('.search-box')) return

  const nextValue = typeof target.value === 'string' ? target.value.trim() : target.value
  if (nextValue === target.value) return

  target.value = nextValue
  target.dispatchEvent(new Event('input', { bubbles: true }))
  target.dispatchEvent(new Event('change', { bubbles: true }))
}

document.addEventListener('focusout', event => {
  trimSearchInputValue(event.target)
})

document.addEventListener('keydown', event => {
  if (event.key !== 'Enter' || event.isComposing) return
  trimSearchInputValue(event.target)
})

const app = createApp(App)

// 全局注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.config.globalProperties.$hasAuth = hasAuth
app.config.globalProperties.$hasBtnAuth = hasBtnAuth
app.config.globalProperties.$hasPageAuth = hasPageAuth

app.mount('#app')
